<template>
  <div class="jobs-report" v-loading="loading">
    <div class="job-row-container">
      <i :class="['fas fa-chevron-right', {expand: expand}]" @click="expandHandler"></i>

      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </div>
    <div class="wrapper-table">

      <el-table
        :row-class-name="rowClassName"
        class="sticky-header-table"
        height="calc(100vh - 120px)"
        default-expand-all
        :data="filteredTableData"
        ref="table"
        style="width: 100%;margin-bottom: 20px;"
        row-key="key"
      >
        <el-table-column
          prop="name"
          min-width="300"
          label="Наименование"
        >
          <template slot-scope="scope">
          <span v-if="!scope.row.isChild" class="parent">
            <strong class="name-abs">
              {{ scope.row.name }}
            </strong>
          </span>
            <span v-else>
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="executor"
          label="Исполнитель"
          min-width="220"
        >
        </el-table-column>
        <el-table-column label="Физ объемы"
                         v-if="config.plan || config.fact || config.diffPlan || config.percentagePlan">
          <el-table-column
            prop="plan"
            v-if="config.plan"

            label="План"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.plan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.plan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fact"
            v-if="config.fact"

            label="Факт"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.fact) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.fact) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="diffPlan"
            v-if="config.diffPlan"

            label="+/-"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.diffPlan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.diffPlan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="percentagePlan"
            v-if="config.percentagePlan"

            label="%"
            width="60">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild" :class=" scope.row.percentagePlan >= 100 ? 'green' : 'red'">
                {{ scope.row.percentagePlan }}
              </strong>
              <span v-else :class=" scope.row.percentagePlan >= 100 ? 'green' : 'red'">
              {{ scope.row.percentagePlan }}
            </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Стоимость"
                         v-if="config.pricePlan || config.priceFact || config.priceDiffPlan || config.pricePercentagePlan">
          <el-table-column
            prop="pricePlan"
            v-if="config.pricePlan"

            label="План"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.pricePlan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.pricePlan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="priceFact"
            v-if="config.priceFact"

            label="Факт"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.priceFact) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.priceFact) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="priceDiffPlan"
            v-if="config.priceDiffPlan"

            label="+/-"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.priceDiffPlan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.priceDiffPlan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="config.pricePercentagePlan"

            prop="pricePercentagePlan"
            label="%"
            width="60">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild" :class=" scope.row.pricePercentagePlan >= 100 ? 'green' : 'red'">
                {{ scope.row.pricePercentagePlan }}
              </strong>
              <span v-else :class="scope.row.pricePercentagePlan >= 100 ? 'green' : 'red'">
              {{ scope.row.pricePercentagePlan }}
            </span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Трудоемкость"
                         v-if="config.laborIntensityPlan || config.laborIntensityFact || config.laborIntensityDiffPlan || config.laborIntensityPercentagePlan">
          <el-table-column
            v-if="config.laborIntensityPlan"

            prop="laborIntensityPlan"
            label="План"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.laborIntensityPlan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.laborIntensityPlan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="laborIntensityFact"
            v-if="config.laborIntensityFact"

            label="Факт"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.laborIntensityFact) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.laborIntensityFact) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="config.laborIntensityDiffPlan"

            prop="laborIntensityDiffPlan"
            label="+/-"
            width="120">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild">
                {{ formatNumberSpace(scope.row.laborIntensityDiffPlan) }}
              </strong>
              <span v-else>
              {{ formatNumberSpace(scope.row.laborIntensityDiffPlan) }}
            </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="config.laborIntensityPercentagePlan"
            prop="laborIntensityPercentagePlan"
            label="%"
            width="60">
            <template slot-scope="scope">
              <strong v-if="!scope.row.isChild"
                      :class="scope.row.laborIntensityPercentagePlan >= 100 ? 'green' : 'red'">
                {{ scope.row.laborIntensityPercentagePlan }}
              </strong>
              <span v-else :class="scope.row.laborIntensityPercentagePlan >= 100 ? 'green' : 'red'">
              {{ scope.row.laborIntensityPercentagePlan }}
            </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {apiUrl} from "../../../plugins/firebase";
import firebase from "firebase";
import dayjs from "dayjs";
import axios from "axios";
import {formatNumberSpace} from "../../../utils/numberUtils";

export default {
  name: "JobReport",
  data() {
    return {
      tableData: [],
      expandedRows: [],
      search: '',
      loading: false,
      expand: true,
      config: {
        plan: false,
        fact: false,
        diffPlan: false,
        percentagePlan: false,
        pricePlan: false,
        priceFact: false,
        priceDiffPlan: false,
        pricePercentagePlan: false,
        laborIntensityPlan: false,
        laborIntensityFact: false,
        laborIntensityDiffPlan: false,
        laborIntensityPercentagePlan: false,
      }
    }
  },
  async mounted() {
    this.loading = true
    let params = encodeURIComponent(`/onGenerateJobsData/${this.$store.state.project.id}`)



    params += `&queryParams=uid=${this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid}`

    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      params += `, planId=${this.$store.state.project.plan.id}`
    }

    if (this.$route.query.isPrice && this.$route.query.isPrice === 'true') {
      params += `, isPrice=true`

    }

    if (this.$route.query.isLaborIntensity && this.$route.query.isLaborIntensity === 'true') {
      params += `, isLaborIntensity=true`

    }

    if (this.$route.query.fromDate && this.$route.query.toDate) {
      const fromDate = dayjs(this.$route.query.fromDate).format('YYYY-MM-DD')
      const toDate = dayjs(this.$route.query.toDate).format('YYYY-MM-DD')

      params += `, fromDate=${fromDate}, toDate=${toDate}`

    }

    const response = await axios.get(`${apiUrl}${params}`);

    if (response && response.data && response.data.data && response.data.data.jobsData && response.data.data.jobsData.objects) {
      let objects = Object.values(response.data.data.jobsData.objects).map((d, i) => {
        d.key = d.name + d.id +  d.index + '_' + i


        return d
      });


      console.log(response.data.data, 'response.data.data.jobsData.')
      objects = objects.map((obj, id) => {
        obj.children = Object.values(obj.jobs).map((j, id) => {
          Object.keys(j).forEach((k) => {
            if (this.config[k] !== undefined) {
              this.config[k] = true
            }
          })
          j.isChild = true
          j.id = id;
          j.key = id + obj.name + j.id + j.name

          return j
        })

        if (!obj.children.length) {
          obj.children = [{
            diffPlan: "",
            executor: "",
            fact: "",
            id: '',
            key: obj.name + id,
            index: '',
            isHide: true,
            isChild: '',
            name: "-",
            percentagePlan: "",
            plan: ""
          }]
        }
        obj.id = id
        return obj
      })


      if(this.$route.query.isLaborIntensity || this.$route.query.isPrice ) {
        objects[objects.length] = {
          name: 'Итого',
          isTotal: true,
          ...response.data.data.jobsData,

          children: [{
            diffPlan: "",
            executor: "",
            fact: "",
            id: '',
            index: '',
            key:  'total',
            isHide: true,
            isChild: '',
            name: "-",
            percentagePlan: "",
            plan: ""
          }]
        }
      }

      this.tableData = objects;

      console.log( this.tableData, ' this.tableData')
      this.loading = false
    }
  },
  computed: {
    // Фильтрация данных по названию (name) для родителей и детей
    filteredTableData() {

      return this.tableData.filter(data => !this.search || ((data && data.name) ||  '').toLowerCase().includes(this.search.toLowerCase()))

    },
  },
  methods: {
    rowClassName(row) {
      if(row.row.isTotal) {
        return  'isTotal'
      }
      if(row.row.isHide) {
        return  'isHide'
      }

      if (!row.row.isChild) {
        return 'isParent'
      }


      return ''
    },
    formatNumberSpace,
    expandHandler() {
      if (this.expand) {
        this.collapseAll()
      } else {
        this.expandAll()
      }

      this.expand = !this.expand
    },
    expandAll() {
      this.filteredTableData.forEach(row => {
        if (!this.expandedRows.includes(row.id)) {
          this.$refs.table.toggleRowExpansion(row, true);
          this.expandedRows.push(row.id);
        }
      });
    },
    collapseAll() {
      this.filteredTableData.forEach(row => {
        this.$refs.table.toggleRowExpansion(row, false);
      });
      this.expandedRows = [];
    },
  },
}
</script>
<style lang="scss">
.jobs-report {

  .el-table__indent {
    display: none !important;
  }

  .el-table__header {
     .el-table__cell {
      padding: 4px 0;
    }
  }
}
</style>
<style scoped lang="scss">
.wrapper-table {
  padding-bottom: 3px;
}
.green {
  color: #13ce66;
}

.expand {
  transform: rotate(90deg);
}

.job-row-container {
  display: flex;
  align-items: center;
  width: 400px;
  margin-bottom: 12px;

  .fa-chevron-right {
    margin-right: 14px;
    margin-left: 10px;
    font-size: 16px;
    cursor: pointer;
  }
}

.red {
  color: red;
}

.jobs-report {
  max-width: 1320px;
  margin: 0 auto;
  width: calc(100% - 40px);
  .el-table .el-table__cell {
    padding: 4px 0;
  }
  margin-top: -24px !important;
}

.name-abs {
  width: 850px;
  position: absolute;
  z-index: 6;

  background: #fff;
  height: 46px;
  align-items: center;
  display: inline-flex;
  margin-top: -12px;
}

</style>

<style lang="scss">
.jobs-report {

  .isParent{
    td, .name-abs {
      background: #f7f7df !important;
    }
    &:hover td.el-table__cell {
      background: #f7f7df !important;
    }
  }

  .el-table--enable-row-hover .el-table__body tr.isParent:hover>td.el-table__cell{
    background: #f7f7df !important;
  }

  .isTotal {
    background: rgba(50, 205, 50, 0.2);
    .name-abs {
      background: rgba(0,0,0,0);
    }
    .el-table__expand-icon {
      opacity: 0;
      width: 0;
    }
  }
  .isHide {
    display: none;
  }
  .el-table__header {
    .el-table .el-table__cell {
      padding: 4px 0;
    }
  }
}
.jobs-report {
  .el-table__expand-icon {
    .el-icon-arrow-right:before {
      content: "\f054" !important;
    }

    .el-icon-arrow-right {
      font-size: 14px !important;
      font-family: 'Font Awesome 5 Free' !important;
      speak: none;
      font-weight: 900 !important;
    }
  }


  .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background: #fff !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/JobsReport.vue